import React from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

export interface ISortOption {
  key: string;
  show: string;
  colName: string;
}

interface Props {
  options: ISortOption[];
  sortChanged: (option: ISortOption) => void;
}

interface State {
  active: ISortOption;
  open: boolean;
}

class SortDropdown extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      active: props.options[0],
      open: false,
    };
  }

  openDropdown = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  selectItem = e => {
    let index = this.props.options.findIndex(
      elem => elem.show === e.currentTarget.textContent
    );
    this.setState(
      {
        active: this.props.options[index],
        open: false,
      },
      () => this.props.sortChanged(this.state.active)
    );
  };

  render() {
    return (
      <div className={s.inlineDropdown}>
        <Dropdown isOpen={this.state.open} toggle={this.openDropdown}>
          <DropdownToggle caret className={s.dropdown} color={"none"}>
            {this.state.active.show.length > 20
              ? this.state.active.show.substring(0, 20) + "..."
              : this.state.active.show}
          </DropdownToggle>
          <DropdownMenu className={s.dropdownMenu}>
            {this.props.options.map(option => (
              <div
                key={option.key}
                onClick={this.selectItem}
                className={
                  this.state.active.key === option.key
                    ? s.dropdownItemActive
                    : s.dropdownItem
                }
              >
                {option.show}
              </div>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default withStyles(s)(SortDropdown);
